/* eslint-disable react/prefer-stateless-function */
import React from "react";
import { positions, useAlert } from "react-alert";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  clearCompany,
  clearGeneral,
  createCompany,
  fetchBrokerageHouses,
  fetchPcoTpa,
  setLoading,
  updateCompany,
} from "../../../../actions";
import styles from "../../../shared/company-enrolment/Company.module.css";
import AddBankAccount from "./enrolmentPages/AddBankAccount";
import Contacts from "./enrolmentPages/Contacts";
import Corporate from "./enrolmentPages/Corporate";
import CorporateFull from "./enrolmentPages/CorporateFull";
import EnrolmentSuccess from "./enrolmentPages/EnrolmentSuccess";
import ProgramVariablesCompany from "./enrolmentPages/ProgramVariablesCompany";
import ReviewInformation from "./enrolmentPages/ReviewInformation";
import GradientText from "../../../shared/GradientText/GradientText";

const EnrolmentPageMapper = (props) => {
  let view = props.view;
  React.useEffect(() => {
    if (
      props.errorMessage &&
      props.errorMessage?.toLowerCase() !== "invalid verification code"
    ) {
      alert.show(props.errorMessage, {
        position: positions.TOP_CENTER,
        type: "error",
        onClose: () => {
          props.setLoading({
            error: false,
            errorMessage: null,
            success: false,
            successMessage: null,
          });
        },
      });
    } else {
      alert.removeAll();
    }
  }, [props.errorMessage]);

  React.useEffect(() => {
    if (props.selfEnrolment.saveSelfEnrolmentCompanyDataFailed === true) {
      let msg =
        props.errorMessage?.toLowerCase() === "invalid verification code"
          ? "Verification code has expired. Please log in again."
          : "Failed to save data. Please try again or contact support at support@ayacare.com.";
      alert.show(
        {
          rawMessage: msg,
        },
        {
          position: positions.TOP_CENTER,
          type: "error",
          onClose: () => {
            props.setLoading({
              error: false,
              errorMessage: null,
              success: false,
              successMessage: null,
            });
          },
        }
      );
    } else {
      alert.removeAll();
    }

    if (props?.errorMessage?.toLowerCase() === "invalid verification code") {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }, [props.selfEnrolment.saveSelfEnrolmentCompanyDataFailed]);

  React.useEffect(() => {
    if (props.selfEnrolment.submitSelfEnrolmentCompanyDataFailed === true) {
      alert.show(
        {
          rawMessage:
            "Failed to submit data. Please try again or contact support at support@ayacare.com.",
        },
        {
          position: positions.TOP_CENTER,
          type: "error",
          onClose: () => {
            props.setLoading({
              error: false,
              errorMessage: null,
              success: false,
              successMessage: null,
            });
          },
        }
      );
    } else {
      alert.removeAll();
    }
  }, [props.selfEnrolment.submitSelfEnrolmentCompanyDataFailed]);

  const someFunction = (val) => {};

  const setView = (view) => {
    view = view;
  };

  const updateView = (view) => {
    setView(view);
  };

  const stepOneView = () => (
    <Corporate updateView={(view) => updateView(view)} styles={styles} />
  );
  const stepTwoView = () => (
    <ProgramVariablesCompany
      updateView={(view) => updateView(view)}
      styles={styles}
    />
  );
  const stepThreeView = () => (
    <CorporateFull updateView={(view) => updateView(view)} styles={styles} />
  );
  const stepFourView = () => (
    <Contacts updateView={(view) => updateView(view)} styles={styles} />
  );
  const stepFiveView = () => (
    <AddBankAccount updateView={(view) => updateView(view)} styles={styles} />
  );
  const stepSixView = () => (
    <ReviewInformation
      updateView={(view) => updateView(view)}
      styles={styles}
    />
  );
  const stepSevenView = () => (
    <EnrolmentSuccess updateView={(view) => updateView(view)} styles={styles} />
  );

  const alert = useAlert();

  switch (view) {
    case "STEP_ONE":
      view = stepOneView();
      break;
    case "STEP_TWO":
      view = stepTwoView();
      break;
    case "STEP_THREE":
      view = stepThreeView();
      break;
    case "STEP_FOUR":
      view = stepFourView();
      break;
    case "STEP_FIVE":
      view = stepFiveView();
      break;
    case "STEP_SIX":
      view = stepSixView();
      break;
    case "STEP_SEVEN":
      view = stepSevenView();
      break;
    default:
      view = stepOneView();
  }

  return (
    <div className={styles.container}>
      <div className={styles.subHeader}>
        <div className={styles.leftSubHeader} />
        {props.view !== "STEP_SEVEN" && (
          <div className={styles.centerSubHeader}>
            <GradientText
              string={props.largeHeader}
              fontSize={"1.8rem"}
              extraStyles={{ fontWeight: "bold" }}
            />
            {/* <span className={styles.largeHeader}>{props.largeHeader}</span> */}
            <span className={styles.smallHeader}>{props.largeSubHeader}</span>
          </div>
        )}
      </div>
      <form style={{ alignSelf: "center" }}>{view}</form>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const data = state.companyReducer.selfEnrolment.companyData ?? {};
  //   let { view, largeHeader, largeSubHeader, errorMessage } =
  //     state.generalReducer;
  const business = data.business ? data.business : {};
  const person = data.person ? data.person : {};
  const selfEnrolment = state.companyReducer.selfEnrolment ?? {};

  let { view, largeHeader, largeSubHeader, errorMessage } =
    state.generalReducer;

  view = view ? view : "STEP_ONE";
  // largeHeader = view === "STEP_ONE" ? "Add Company" : largeHeader;
  largeHeader =
    view === "STEP_ONE" ? "Getting Started With Aya" : "Welcome to AyaCare!";
  largeSubHeader = view === "STEP_ONE" ? "" : largeSubHeader;
  return {
    errorMessage,
    view,
    largeHeader,
    largeSubHeader,
    usersFirstName: person ? person.firstName : "",
    usersLastName: person ? person.lastName : "",
    usersEmail: person ? person.email : "",
    usersID:
      person && person.personGuid ? person.personGuid.split("-")[0] : "no ID",
    companiesBusinessName: business ? business.businessOperatedName : "",
    selfEnrolment,
  };
};

export default connect(mapStateToProps, {
  createCompany,
  fetchBrokerageHouses,
  fetchPcoTpa,
  updateCompany,
  clearCompany,
  clearGeneral,
  setLoading,
})(withRouter(EnrolmentPageMapper));
